import apiFetch from '../apiFetch'

export default function (idCopiaSeguridad, token) {
  return apiFetch({endPoint: `CopiaSeguridad/eliminarCopiaSeguridad?idCopiaSeguridad=` + idCopiaSeguridad, method: 'GET', body: null, token: token})
}